import workerUrl from "pdfjs-dist/legacy/build/pdf.worker.min.mjs?url";

/** Der Typ des pdf.js-Moduls — die legacy-Fassung exportiert dieselben Namen wie die moderne. */
export type Pdfjs = typeof import("pdfjs-dist/legacy/build/pdf.mjs");

let loaded: Promise<Pdfjs> | null = null;

/**
 * Lädt pdf.js GENAU EINMAL als eigenen Chunk (dynamischer Import: die Anwendungshülle
 * wächst nicht um die Bibliothek) und setzt den Worker, der als Vite-Asset im eigenen
 * Bündel liegt — kein CDN. Legacy-Fassung (Spec, Entscheid 799): Die moderne setzt
 * Sprachfunktionen voraus, die erst die jüngsten Browser haben; ein iPad, das nicht auf
 * dem letzten Stand ist, bekäme ohne Rückfall nur den Fehlerstand.
 */
export function loadPdfjs(): Promise<Pdfjs> {
  // Schlägt das Nachladen fehl (Netz, neues Bündel nach einem Deploy), wird das abgelehnte
  // Versprechen NICHT gemerkt: Sonst wäre ein einmaliger Fehler für die ganze Sitzung
  // endgültig, und „Neu rendern“ versuchte es nie wieder (Review Task 4).
  loaded ??= import("pdfjs-dist/legacy/build/pdf.mjs").then((pdfjs) => {
    pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;
    return pdfjs;
  }).catch((e: unknown) => {
    loaded = null;
    throw e;
  });
  return loaded;
}
